import React, { useRef, useState } from 'react';
import { bell } from 'static/icons/resizable';
import { Icon, Text } from 'view/atoms';
import { useShouldShowNotificationBubble, useOnClickOutside } from 'hooks';
import { useTranslation } from 'react-i18next';
import { NotificationList } from 'view/molecules/NotificationList';
import * as S from './NotificationsMenu.styles';

export const HeaderNotificationsMenu = () => {
  const [isMenuShown, setIsMenuShown] = useState(false);
  const { t } = useTranslation();

  const buttonNode = useRef<HTMLDivElement>(null);
  const menuNode = useRef<HTMLDivElement>(null);
  useOnClickOutside([buttonNode, menuNode], () => setIsMenuShown(false));

  const showNotificationBubble = useShouldShowNotificationBubble();

  return (
    <S.NotificationsMenuWrapper>
      <S.NotificationsButton
        data-testid='Header-NotificationBell'
        ref={buttonNode}
        active={isMenuShown}
        onClick={() => setIsMenuShown(!isMenuShown)}
      >
        <Icon src={bell} alt='Notification Bell' />
        {showNotificationBubble && (
          <S.IconBubble aria-label='Notification bubble' />
        )}
      </S.NotificationsButton>

      {isMenuShown && (
        <S.NotificationsMenu ref={menuNode}>
          <Text kind='h4'>{t('other.notifications')}</Text>
          <NotificationList />
        </S.NotificationsMenu>
      )}
    </S.NotificationsMenuWrapper>
  );
};
